import React from 'react';
import { scaffoldingRows } from '../data/content';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
export function Scaffolding() {
  return <section className="relative w-full overflow-hidden bg-night px-5 py-20 sm:py-28" data-id="element-209" data-mp="2k487mcujx03q">
      <div className="bg-stripes absolute inset-0" aria-hidden="true" data-id="element-210" data-mp="2k1vss8k3b5uw" />
      <div className="relative mx-auto max-w-6xl" data-id="element-211" data-mp="2g34tpvw2de55">
        <SectionHeading eyebrow="Andamiaje lingüístico" tone="dark" title={<>
              La estrategia de{' '}
              <span className="text-volt" data-id="element-213" data-mp="1nf0mh5xugt0c">Scaffolding</span>
            </>} subtitle="Para que ningún alumno se bloquee y tú no tengas que traducir cada instrucción: el kit define cuánto inglés y cuánto español usar en cada etapa." data-id="element-212" data-mp="1sciy5438xmc1" />

        <Reveal delay={0.06} data-id="element-214" data-mp="1wdcl9v8v6x3v">
          <div className="no-scrollbar mt-14 overflow-x-auto rounded-3xl border-2 border-ink bg-white" data-id="element-215" data-mp="18p1pv7lxtpmz">
            <table className="w-full min-w-[760px] border-collapse text-left" data-id="element-216" data-mp="14npyawji6uc5">
              <caption className="sr-only" data-id="element-217" data-mp="14lna8i1wvba2">
                Proporción sugerida de inglés y español por etapa de
                aprendizaje
              </caption>
              <thead data-id="element-218" data-mp="1vbn4xyauge0r">
                <tr className="bg-ink" data-id="element-219" data-mp="1vav9qol5sib0">
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-volt" data-id="element-220" data-mp="2034wxwuw349l">
                    Etapa
                  </th>
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-white/70" data-id="element-221" data-mp="251zs7ya1mlal">
                    Equivalencia sugerida
                  </th>
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-white/70" data-id="element-222" data-mp="1cevgzbkcxaqd">
                    Inglés / Español en el aula
                  </th>
                  <th scope="col" className="px-6 py-4 font-display text-xs tracking-[0.14em] text-white/70" data-id="element-223" data-mp="1mcjl2s3urul7">
                    Enfoque pedagógico
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-224" data-mp="2xq3wqggvosbp">
                {scaffoldingRows.map((row, index) => <tr key={row.stage} className={index > 0 ? 'border-t-2 border-ink/10' : ''} data-id="element-225" data-mp="xoxairvyyc4g" data-mpi={index}>
                    <th scope="row" className="whitespace-nowrap px-6 py-6 align-top font-display text-lg text-ink" data-id="element-226" data-mp="sq2s3r1wypkv">
                      {row.stage}
                    </th>
                    <td className="px-6 py-6 align-top text-sm font-semibold leading-snug text-ink/60" data-id="element-227" data-mp="16nrdr13t20qz">
                      {row.equivalence}
                    </td>
                    <td className="px-6 py-6 align-top" data-id="element-228" data-mp="ezhae5o74lok">
                      <div className="flex h-3 w-full min-w-[9rem] overflow-hidden rounded-full border border-ink/15" aria-hidden="true" data-id="element-229" data-mp="9zuxjxca57ga">
                        <span className="block bg-brand" style={{
                      width: `${row.englishPct}%`
                    }} data-id="element-230" data-mp="nrsxpio0jt0b" />
                        <span className="block bg-volt" style={{
                      width: `${100 - row.englishPct}%`
                    }} data-id="element-231" data-mp="iyg9var5rq8m" />
                      </div>
                      <p className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-1 text-sm font-bold" data-id="element-232" data-mp="3ne91tc4ofa4w">
                        <span className="text-brand" data-id="element-233" data-mp="3d99drtrcmj09">
                          Inglés {row.english}
                        </span>
                        <span className="text-ink/45" data-id="element-234" data-mp="33cmwtg258c3i">
                          Español {row.spanish}
                        </span>
                      </p>
                    </td>
                    <td className="px-6 py-6 align-top text-base leading-snug text-ink/80" data-id="element-235" data-mp="3894xa3qfxoa1">
                      {row.focus}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Reveal>

        <p className="mt-5 text-center text-xs font-semibold uppercase tracking-[0.14em] text-white/40 sm:hidden" data-id="element-236" data-mp="3m1ulmetfz5ab">
          Desliza para ver la tabla completa →
        </p>
      </div>
    </section>;
}